import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Enquiry Numbers</h1>
                <p>Home &gt; Enquiry Numbers</p>
            </div>
        </div>
    )
}

export default Hero;